import React, { useState, useEffect } from "react";
import { doc, getDoc, updateDoc, getFirestore, arrayRemove, arrayUnion } from "firebase/firestore";
import { app } from '../../credenciales'; // Asegúrate de importar tu configuración de Firebase
import { useParams } from 'react-router-dom';
import { Button, Form, Row, Col, Alert, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import style from "../Perfil/Perfil.module.css";
import Swal from 'sweetalert2';

const db = getFirestore(app);

const EditarActividad = ({ id, handleCloseEditModal }) => {
  //const { idActividad } = useParams(); // Obtiene el ID de la actividad desde los parámetros de la URL
  const [activityData, setActivityData] = useState(null); // Para almacenar los datos de la actividad
  const [nombre, setNombre] = useState(""); // Para manejar el nombre de la actividad
  const [isSingleClass, setIsSingleClass] = useState(false); // Para manejar el checkbox isSingleClass
  const [fechas, setFechas] = useState([]); // Para manejar las fechas
  const [hora, setHora] = useState("");
  const [error, setError] = useState(''); // Para manejar los mensajes de error

  // Cargar la actividad desde Firestore
  useEffect(() => {
    const getActivityData = async () => {
      const docRef = doc(db, "actividades", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setActivityData(data);
        setNombre(data.nombre);
        setIsSingleClass(data.isSingleClass);
        setFechas(data.fechas || []); // Asegúrate de que fechas esté siempre como un array vacío si no existe
        setHora(data.hora || "");
      } else {
        console.log("No se encontró la actividad");
      }
    };

    getActivityData();
  }, [id]);

  // Función para manejar el cambio en el nombre
  const handleNameChange = (e) => setNombre(e.target.value);;

  const handleHourChange = (e) => setHora(e.target.value);

  // Función para manejar el cambio en el checkbox isSingleClass
  const handleCheckboxChange = () => {
    setIsSingleClass(!isSingleClass);
    // Si se cambia a una sola clase, eliminar todas las fechas excepto la primera
    if (isSingleClass) {
      setFechas([fechas[0]]);
    }
  };

  // Función para manejar el cambio en las fechas
  const handleDateChange = (e, index) => {
    const updatedDates = [...fechas];

    // Aquí mantenemos los usuarios que ya estaban inscritos en esa fecha
    updatedDates[index] = {
      ...updatedDates[index], // Mantenemos el objeto de la fecha original
      fecha: e.target.value,   // Actualizamos solo la fecha
    };

    setFechas(updatedDates); // Actualizamos el estado local con la fecha modificada
  };


  const handleAddDate = async () => {
    const newDate = ""; // Fecha vacía por defecto

    // Obtener los usuarios de las fechas existentes
    const usuariosInscritos = [];
    fechas.forEach((fecha) => {
      if (fecha.usuarios) {
        fecha.usuarios.forEach((usuario) => {
          // Verificamos si el usuario ya existe en el array
          if (!usuariosInscritos.some(u => u.id === usuario.id)) {
            // Añadimos al usuario con 'presente' como false
            usuariosInscritos.push({ ...usuario, presente: false });
          }
        });
      }
    });

    // Crear una nueva fecha con los usuarios inscritos
    const newDateWithUsers = {
      fecha: newDate, // Fecha vacía, puedes cambiar esto dependiendo de tu lógica
      usuarios: usuariosInscritos, // Los usuarios de las fechas existentes con 'presente' a false
    };

    setFechas([...fechas, newDateWithUsers]); // Agregar la nueva fecha al estado

    // Agregar la nueva fecha con los usuarios a Firestore
    const docRef = doc(db, "actividades", id);
    try {
      await updateDoc(docRef, {
        fechas: arrayUnion(newDateWithUsers), // Agregar la nueva fecha con los usuarios
      });
    } catch (error) {
      console.error("Error al agregar fecha:", error);
    }
  };

  // Función para manejar la eliminación de una fecha
  const handleDeleteDate = async (date, index) => {
    const docRef = doc(db, "actividades", id);

    try {
      // Eliminar la fecha de Firestore
      await updateDoc(docRef, {
        fechas: arrayRemove(date) // Eliminar la fecha específica del array de fechas
      });

      // Actualizar el estado local para reflejar la eliminación
      const updatedDates = fechas.filter((_, i) => i !== index);
      setFechas(updatedDates);
    } catch (error) {
      console.error("Error al eliminar la fecha:", error);
    }
  };

  const handleSaveChanges = async () => {
    if (!nombre || (fechas.length === 0 || (isSingleClass && !fechas[0]))) {
      setError("Por favor, complete todos los campos.");
      return;
    }

    try {
      const docRef = doc(db, "actividades", id);

      // Usamos las fechas que ya han sido actualizadas por handleDateChange
      await updateDoc(docRef, {
        nombre: nombre,
        hora: hora,
        isSingleClass: isSingleClass,
        fechas: fechas // Las fechas ya tienen los usuarios y las modificaciones
      });

      Swal.fire({
        title: "Actividad actualizada correctamente.",
        icon: "success"
      });
      handleCloseEditModal();
    } catch (error) {
      console.error("Error al actualizar la actividad: ", error);
      setError("Hubo un error al guardar los cambios.");
    }
  };


  return (
    <Container className="py-4">
      {activityData ? (
        <Form>
          <Form.Group as={Row} controlId="nombre">
            <Form.Label column sm={2}>Nombre de la actividad</Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                value={nombre}
                onChange={handleNameChange}
                required
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="hora">
            <Form.Label column sm={2}>Hora de la actividad</Form.Label>
            <Col sm={10}>
              <Form.Control
                type="time"
                value={hora}
                onChange={handleHourChange}
                required
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="isSingleClass">
            <Form.Label column sm={2}>Clase única</Form.Label>
            <Col sm={10}>
              <Form.Check
                type="checkbox"
                checked={isSingleClass}
                onChange={handleCheckboxChange}
              />
            </Col>
          </Form.Group>

          <h3>Fechas de la actividad:</h3>
          {isSingleClass ? (
            <Form.Group as={Row} controlId="fecha">
              <Col sm={10}>
                <Form.Control
                  type="date"
                  value={fechas[0] || ""}
                  onChange={(e) => handleDateChange(e, 0)}
                  required
                />
              </Col>
            </Form.Group>
          ) : (
            fechas.map((date, index) => (
              <Row key={index} className="mb-2">
                <Col sm={10}>
                  <Form.Control
                    type="date"
                    value={date.fecha}
                    onChange={(e) => handleDateChange(e, index)}
                    required
                  />
                </Col>
                <Col sm={2}>
                  <Button
                    variant="danger"
                    type="button"
                    onClick={() => handleDeleteDate(date, index)}
                  >
                    Eliminar
                  </Button>
                </Col>
              </Row>
            ))
          )}

          {!isSingleClass && (
            <Button
              variant="dark"
              type="button"
              onClick={handleAddDate}
            >
              Agregar Fecha
            </Button>
          )}

          {error && <Alert variant="danger">{error}</Alert>}
          <br /><br />
          <Row>
            <Col className="d-flex justify-content-end">
              <Button variant="dark" onClick={handleCloseEditModal}>
                Cancelar
              </Button>
              <Button variant="dark" onClick={handleSaveChanges} className="mx-4">
                Guardar Cambios
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <p>Cargando datos...</p>
      )}
    </Container>
  );
};

export default EditarActividad;
